__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "help-centre";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query", "5.102.8", () => (__webpack_require__.e(406).then(() => (() => (__webpack_require__(4406))))));
			register("next/compat/router", "15.5.18", () => (() => (__webpack_require__(4435))), 1);
			register("next/dynamic", "15.5.18", () => (__webpack_require__.e(988).then(() => (() => (__webpack_require__(5988))))));
			register("next/head", "15.5.18", () => (() => (__webpack_require__(633))), 1);
			register("next/image", "15.5.18", () => (__webpack_require__.e(128).then(() => (() => (__webpack_require__(8128))))));
			register("next/link", "15.5.18", () => (() => (__webpack_require__(8591))), 1);
			register("next/router", "15.5.18", () => (() => (__webpack_require__(7170))), 1);
			register("next/script", "15.5.18", () => (__webpack_require__.e(648).then(() => (() => (__webpack_require__(3648))))));
			register("react-dom", "19.1.0", () => (() => (__webpack_require__(4518))), 1);
			register("react-i18next", "15.7.4", () => (__webpack_require__.e(386).then(() => (() => (__webpack_require__(8386))))));
			register("stores/use-basket-store", "1.0.0", () => (() => (__webpack_require__(2458))), 1);
			register("stores/use-breadcrumb-store", "1.0.0", () => (() => (__webpack_require__(1017))), 1);
			register("stores/use-user-store", "1.0.0", () => (() => (__webpack_require__(484))), 1);
			register("zod", "3.25.76", () => (__webpack_require__.e(192).then(() => (() => (__webpack_require__(1192))))));
			register("zustand", "4.5.7", () => (() => (__webpack_require__(9971))), 1);
			register("react-dom/client", "19.1.0", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(2181))))));
			register("react/jsx-runtime", "19.1.0", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4489))))));
			register("react", "19.1.0", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4349))))));
			register("styled-jsx/style", "5.1.6", () => (__webpack_require__.e(19).then(() => (() => (__webpack_require__(19))))));
			register("styled-jsx", "5.1.6", () => (__webpack_require__.e(738).then(() => (() => (__webpack_require__(7738))))));
			initExternal(1305);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};